// extracted by mini-css-extract-plugin
export default {"productGrid":"u0-z","centerLink":"v0-z","productSection":"w0-z","item":"x0-z","ctaButton":"y0-z"};